import React from 'react'
import './SearchIcon.css'
import Footer from '../../component/Footer/Footer';
import LayoutWrapper from '../../component/LayoutWrapper/';
import product1 from '../../assets/images/products/product-1.jpg';
import product2 from '../../assets/images/products/product-2.jpg';
import product3 from '../../assets/images/products/product-3.jpg';
import product4 from '../../assets/images/products/product-4.jpg';
import product5 from '../../assets/images/products/product-5.jpg';
import product6 from '../../assets/images/products/product-6.jpg';
import product7 from '../../assets/images/products/product-7.jpg';
import product8 from '../../assets/images/products/product-8.jpg';
import product9 from '../../assets/images/products/product-9.jpg';
import product10 from '../../assets/images/products/product-10.jpg';
import product11 from '../../assets/images/products/product-11.jpg';
import product12 from '../../assets/images/products/product-12.jpg';
import { Link } from 'react-router-dom';


class SearchIcon extends React.PureComponent {
    render() {
        return (        
            <div className="page-wrapper">
                <LayoutWrapper />
                    <main className="main main-container">
                        <div className="banner banner-cat bg-img">
                            <div className="banner-content container">
                                <h2 className="banner-subtitle">check out over <span>200+</span></h2>
                                <h1 className="banner-title">
                                    INCREDIBLE deals
                                </h1>
                                <a href="/" className="btn btn-primary">Shop Now</a>
                            </div>
                            {/* End .banner-content */}
                        </div>
                        {/* End .banners */}
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/">Shop</a></li>
                                    <li className="breadcrumb-item"><a href="/">SEARCHRDESULTFOR</a></li>
                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9">
                                    <nav className="toolbox">
                                        <div className="toolbox-left">
                                            <div className="toolbox-item toolbox-sort">
                                                <div className="select-custom">
                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">Default sorting</option>
                                                        <option value="popularity">Sort by popularity</option>
                                                        <option value="rating">Sort by average rating</option>
                                                        <option value="date">Sort by newness</option>
                                                        <option value="price">Sort by price: low to high</option>
                                                        <option value="price-desc">Sort by price: high to low</option>
                                                    </select>
                                                </div>
                                                {/* End .select-custom */}
                                                <a href="/" className="sorter-btn" title="Set Ascending Direction"><span className="sr-only">Set Ascending Direction</span></a>
                                            </div>
                                            {/* End .toolbox-item */}
                                        </div>
                                        {/* End .toolbox-left */}

                                        <div className="toolbox-item toolbox-show">
                                            <label>Showing 1–9 of 60 results</label>
                                        </div>
                                        {/* End .toolbox-item */}

                                        <div className="layout-modes">
                                            <a href="/" className="layout-btn btn-grid active" title="Grid">
                                                <i className="icon-mode-grid"></i>
                                            </a>
                                            <a href="/" className="layout-btn btn-list" title="List">
                                                <i className="icon-mode-list"></i>
                                            </a>
                                        </div>
                                        {/* End .layout-modes */}
                                    </nav>
                                    <div className="row row-sm">
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product1} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product2} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product3} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product4} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                            <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product5} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="product.html">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product6} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product7} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product8} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product9} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product10} alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>    
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}>
                                                    <figure>
                                                        <a href="/">
                                                            <img src={product11}  alt="img"/>
                                                        </a>
                                                    </figure>
                                                </Link>
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                        <div className="col-6 col-md-4 col-xl-3">
                                            <div className="product-default">
                                                <Link to={'/productview'}><figure>
                                                    <a href="/">
                                                        <img src={product12} alt="img"/>
                                                    </a>
                                                </figure>
                                                </Link>
                                                <div className="product-details">
                                                    <div className="ratings-container">
                                                        <div className="product-ratings">
                                                            <span className="ratings" style={{"width":"100%"}}></span>
                                                            {/* End .ratings */}
                                                        </div>
                                                        {/* End .product-ratings */}
                                                    </div>
                                                    {/* End .product-container */}
                                                    <h2 className="product-title">
                                                        <a href="/">Product Short Name</a>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="product-price">$32.00</span>
                                                    </div>
                                                    {/* End .price-box */}
                                                    <div className="product-action">
                                                        <a href="/" className="btn-icon-wish"><i className="icon-heart"></i></a>
                                                        <Link to={'/productview'}><button className="btn-icon btn-add-cart" data-toggle="modal" data-target="#addCartModal"><i className="icon-bag"></i>ADD TO CART</button>
                                                        </Link>
                                                        <a href="/" className="btn-quickview" title="Quick View"><i className="fas fa-external-link-alt"></i></a> 
                                                    </div>
                                                </div>
                                                {/* End .product-details */}
                                            </div>
                                        </div>
                                        {/* End .col-xl-3 */}
                                    </div>
                                    <nav className="toolbox toolbox-pagination">
                                        <div className="toolbox-item toolbox-show">
                                            <label>Showing 1–9 of 60 results</label>
                                        </div>
                                        {/* End .toolbox-item */}
                                        <ul className="pagination">
                                            <li className="page-item disabled">
                                                <a className="page-link page-link-btn" href="/"><i className="icon-angle-left"></i></a>
                                            </li>
                                            <li className="page-item active">
                                                <a className="page-link" href="/">1 <span className="sr-only">(current)</span></a>
                                            </li>
                                            <li className="page-item"><a className="page-link" href="/">2</a></li>
                                            <li className="page-item"><a className="page-link" href="/">3</a></li>
                                            <li className="page-item"><a className="page-link" href="/">4</a></li>
                                            <li className="page-item"><span>...</span></li>
                                            <li className="page-item"><a className="page-link" href="/">15</a></li>
                                            <li className="page-item">
                                                <a className="page-link page-link-btn" href="/"><i className="icon-angle-right"></i></a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                {/* End .col-lg-9 */}
                                <aside className="sidebar-shop col-lg-3 order-lg-first">
                                    <div className="sidebar-wrapper">
                                    <div className="widget">
                                            <h3 className="widget-title">
                                                <a data-toggle="collapse" href="/widget-body-2" role="button" aria-expanded="true" aria-controls="widget-body-2">BROWSE</a>
                                            </h3>
                                            <div className="collapse show" id="widget-body-2">
                                                <div className="widget-body">
                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">COMBOS</option>
                                                        <option value="popularity">DESIGN YOUR OWN COMBOS</option>
                                                        <option value="rating">SON AND FATHER</option>
                                                    </select>
                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">CUSTOMIZED GIFT</option>
                                                        <option value="popularity">CLOCK</option>
                                                        <option value="rating">CUT OUTS</option>
                                                        <option value="rating">PHOTO FRAMES</option>
                                                        <option value="rating">WOODEN CRAFT</option>
                                                    </select>
                                                    <div className="form-control">KEY CHAIN</div>
                                                    <select name="orderby" className="form-control">
                                                            <option value="menu_order" selected="selected">KIDS</option>
                                                            <option value="popularity">CRICKET FEVER KID</option>
                                                            <option value="rating">DESIGN YOUR OWN TEES KIDS</option>
                                                            <option value="rating">GRADUATION</option>
                                                            <option value="rating">PLAIN TEES KIDS</option>
                                                    </select>
                                                    <select name="orderby" className="form-control">
                                                            <option value="menu_order" selected="selected">MENS</option>
                                                            <option value="popularity">CARTOONS TEES</option>
                                                            <option value="rating">CRICKET FEVER MENS</option>
                                                            <option value="rating">DESIGN YOUR OWN TEES MENS</option>
                                                            <option value="rating">FITNESS AND SPORTS</option>
                                                            <option value="rating">FUNKY</option>
                                                            <option value="rating">MOTIVATIONAL TEES</option>
                                                            <option value="rating">PLAIN TEES</option>
                                                            <option value="rating">PROGRAMMER</option>
                                                            <option value="rating">SPOOKY</option>
                                                            <option value="rating">TRAVEL AND LOCATION</option>
                                                    </select>
                                                    
                                                    

                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">MOBILE COVER</option>
                                                        <option value="popularity">CRICKET FEVER</option>
                                                        <option value="popularity">FUNKY</option>
                                                        <option value="popularity">SPIRITUAL</option>
                                                        <option value="popularity">SPOOKY</option>
                                                       
                                                    </select>
                                                    <select  name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">DESIGN YOUR OWN COVER </option>
                                                        <option value="rating">Apple</option>
                                                        <option value="rating">Gionee</option>
                                                        <option value="rating">Huawei</option>
                                                        <option value="rating">Lenovo</option>
                                                        <option value="rating">Motorola</option>
                                                        <option value="rating">Nokia</option>
                                                        <option value="rating">Oneplus</option>
                                                        <option value="rating">Oppo</option>
                                                        <option value="rating">Realme</option>
                                                        <option value="rating">Samsung</option>
                                                        <option value="rating">Sony Xperia</option>
                                                        <option value="rating">Vivo</option>
                                                        <option value="rating">Xiaomi</option>
                                                    </select>       
                                                    
                                                           

                                               

                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">MUGS</option>
                                                        <option value="popularity">DESIGN YOUR OWN MUGS</option>
                                                    </select>
                                                    <select name="orderby" className="form-control">
                                                        <option value="menu_order" selected="selected">WOMENS</option>
                                                        <option value="popularity">CRICKET FEVER WOMEN</option>
                                                        <option value="popularity">DESIGN YOUR OWN TEES WOMENS</option>
                                                        <option value="popularity">FUNKY</option>
                                                        <option value="popularity">PLAIN TEES</option>
                                                        <option value="popularity">SPOOKY</option>
                                                    </select>
                                                </div>
                                                {/* End .widget-body */}
                                            </div>
                                            {/* End .collapse */}
                                        </div>
                                        {/* End .widget */}
                                        <div className="widget">
                                            <h3 className="widget-title">
                                                <a data-toggle="collapse" href="/widget-body-6" role="button" aria-expanded="true" aria-controls="widget-body-6">Color</a>
                                            </h3>
                                            <div className="collapse show" id="widget-body-6">
                                                <div className="widget-body">
                                                    <ul className="config-swatch-list">
                                                        <li className="active">
                                                            <a href="/">
                                                                <span className="color-panel bg-clr-mens" ></span>
                                                                <span>Blue</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/">
                                                                <span className="color-panel bg-clr-mens1"></span>
                                                                <span>Red</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/">
                                                                <span className="color-panel bg-clr-mens2"></span>
                                                                <span>Orange</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/">
                                                                <span className="color-panel bg-clr-mens3"></span>
                                                                <span>Green</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* End .widget-body */}
                                            </div>
                                            {/* End .collapse */}
                                        </div>
                                        {/* End .widget */}
                                    </div>
                                    {/* End .sidebar-wrapper */}
                                </aside>
                                {/* End .col-lg-3 */}
                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}

                        <div className="mb-5"></div>
                        {/* margin */}
                    </main>
                    {/* End .main */}
                    <Footer />
        
                </div>
        )
                
                
    }

                       
                    
                  
                
}
export default SearchIcon
